import { createAuthClient } from 'better-auth/vue'
import { passkeyClient } from '@better-auth/passkey/client'

/**
 * Better Auth client for the admin/driver dashboard. Points at the API worker's
 * `/auth` handler (see apps/api/src/auth). `credentials: include` so the session
 * cookie flows to the cross-subdomain API.
 *
 * Auth is passkey-only: the passkey client plugin provides `signIn.passkey()`
 * for login and `passkey.addPasskey()` / `passkey.listUserPasskeys()` /
 * `passkey.updatePasskey()` / `passkey.deletePasskey()` for management in
 * account settings. There is no password sign-in or sign-up — the server has
 * `emailAndPassword` disabled.
 */
export const authClient = createAuthClient({
  baseURL:
    (typeof process !== 'undefined' && process.env.AUTH_BASE_URL) ||
    'https://api.passengerkit.app/auth',
  fetchOptions: {
    credentials: 'include',
  },
  plugins: [passkeyClient()],
})

export const { signIn, signOut, useSession, passkey } = authClient
